import React, { MouseEvent, useContext, useState } from 'react';
import styled from 'astroturf/react';
import { Suggestion } from 'js/social/shared/types';
import AvatarBase from 'js/social/shared/Avatar';
import { Body } from 'js/design_system/Body';
import CloseIcon from 'js/svg/colorless/close.svg';
import { FollowActionButton } from 'js/social/shared/FollowActionButton';
import { ignoreSuggestion } from 'js/profiles/api/suggested_api';
import { Spinner } from 'js/social/shared/CreateSocialItem/Spinner';
import { createUserFollowing } from 'js/social/api';
import { SuggestionReason as SuggestionReasonBase } from 'js/social/suggestions/SuggestionReason';
import { NetworkContext } from 'js/profiles/types';
import _Header from "SuggestionCard-Header.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=Header";
import _Avatar from "SuggestionCard-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=Avatar";
import _ProfileText from "SuggestionCard-ProfileText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=ProfileText";
import _IgnoreButton from "SuggestionCard-IgnoreButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=IgnoreButton";
import _NameText from "SuggestionCard-NameText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=NameText";
import _AffiliationText from "SuggestionCard-AffiliationText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=AffiliationText";
import _SuggestionReason from "SuggestionCard-SuggestionReason.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=SuggestionReason";
import _FollowButton from "SuggestionCard-FollowButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=FollowButton";
import _Container from "SuggestionCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/suggestions/SuggestionCard.tsx?styleId=Container";


const Header = /*#__PURE__*/styled("div", null, {
  displayName: "Header",
  styles: _Header
});

const Avatar = /*#__PURE__*/styled(AvatarBase, null, {
  displayName: "Avatar",
  styles: _Avatar
});

const ProfileText = /*#__PURE__*/styled("div", null, {
  displayName: "ProfileText",
  styles: _ProfileText
});

const IgnoreButton = /*#__PURE__*/styled("div", null, {
  displayName: "IgnoreButton",
  styles: _IgnoreButton
});

const NameText = /*#__PURE__*/styled(Body, null, {
  displayName: "NameText",
  styles: _NameText
});

const AffiliationText = /*#__PURE__*/styled(Body, null, {
  displayName: "AffiliationText",
  styles: _AffiliationText
});

const SuggestionReason = /*#__PURE__*/styled(SuggestionReasonBase, null, {
  displayName: "SuggestionReason",
  styles: _SuggestionReason
});

const FollowButton = /*#__PURE__*/styled(FollowActionButton, null, {
  displayName: "FollowButton",
  styles: _FollowButton
});

const Container = /*#__PURE__*/styled("a", null, {
  displayName: "Container",
  styles: _Container
});

type Props = {
  small?: boolean;
  suggestion: Suggestion;
  suggestionSource: string;
  followSource: string;
  onIgnore?: () => void;
  alwaysShowFollowButton?: boolean;
};

export const SuggestionCard: React.FC<Props> = ({
  small = false,
  suggestion,
  suggestionSource,
  followSource,
  onIgnore,
  alwaysShowFollowButton = false,
}) => {
  const { follow: networkFollow } = useContext(NetworkContext);
  const [follows, setFollows] = useState(suggestion.user.followed || false);
  const [ignored, setIgnored] = useState(false);
  const user = suggestion.user;

  const follow = async () => {
    await createUserFollowing(user.id, followSource, {
      suggestion_reason: suggestionSource,
    });
    networkFollow(user.id, true);
    setFollows(true);
  };

  const ignore = async (event: MouseEvent) => {
    event.preventDefault();
    setIgnored(true);
    await ignoreSuggestion(user.id, suggestionSource);
    if (onIgnore) onIgnore();
  };

  return (
    <Container
      small={small}
      href={ignored ? undefined : user.url}
      ignored={ignored}
      onDragStart={(event) => event.preventDefault()}
      onDragEnd={(event) => event.preventDefault()}
    >
      {ignored ? (
        <Spinner />
      ) : (
        <>
          <Header small={small}>
            <Avatar fullName={user.display_name ?? ''} photoUrl={user.photo} />
            {!follows && onIgnore && (
              <IgnoreButton onClick={ignore}>
                <CloseIcon size={20} color="#B1B1BA" />
              </IgnoreButton>
            )}
          </Header>

          <ProfileText>
            <NameText size="sm" bold>
              {user.display_name}
            </NameText>
            <AffiliationText small={small}>
              {user.department?.university?.name}&nbsp;
            </AffiliationText>
          </ProfileText>

          <SuggestionReason
            small={small}
            source={suggestionSource}
            metadata={suggestion.metadata}
          />

          <FollowButton
            size="xs"
            variant="text"
            userId={user.id}
            follows={follows}
            onFollow={follow}
            alwaysShowFollowButton={alwaysShowFollowButton}
          >
            Follow
          </FollowButton>
        </>
      )}
    </Container>
  );
};
